import { render, staticRenderFns } from "./PreAlert.vue?vue&type=template&id=786cc3ff&"
import script from "./PreAlert.vue?vue&type=script&lang=js&"
export * from "./PreAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports